import React,{ Fragment } from "react";

const Alert = ({data}) => {
    if (!data) {
        return (<Fragment></Fragment>);
    }
    if (data.text === "") {
        return (<Fragment></Fragment>);
    }
    if (data.error) {
        return (<div className="alert-danger" role="alert">
           {data.text}
        </div>)
    }
    return (<div className="alert-success" role="alert">
        {data.text}
    </div>)
}
export default Alert;